export default "/images/2cb5bfcc1c5bc7e31279c6a3f314d3cc.avif";